import { wsClient, WsRecvType, IWsHandler } from '../client'
import { IClientUID } from '../../api/clients'

type IMachineOtaProgressData = {
    clientId: IClientUID
    progress: number
}

type IMachineOtaProgressHandler = IWsHandler<IMachineOtaProgressData>

type IMachineOtaProgressCallback = (clientId: IClientUID, progress: number) => void

export type IListenerUID = number

const listeners_: Array<{ id: IListenerUID; callback: IMachineOtaProgressCallback }> = []
let listenerInc_ = 0

export function MachineOtaProgressHandler() {
    wsClient.submitHandler(WsRecvType.MachineOtaProgress, (({ data }) => {
        console.log(`%c[WsClient][${new Date().toISOString()}] MachineOtaProgress`, 'color: orange', data!.progress, data!.clientId)
        for (const listener of listeners_) {
            listener.callback(data!.clientId, data!.progress)
        }
    }) as IMachineOtaProgressHandler)
}

export function onOtaProgress(callback: IMachineOtaProgressCallback): IListenerUID {
    listenerInc_++
    listeners_.push({ id: listenerInc_, callback })
    return listenerInc_
}

export function clearOtaProgress(id: IListenerUID) {
    const index = listeners_.findIndex(listener => listener.id === id)
    if (index !== -1) {
        listeners_.splice(index, 1)
    }
}
